import { render, staticRenderFns } from "./TourIntroComponent.vue?vue&type=template&id=6c2d5908&scoped=true"
import script from "./TourIntroComponent.vue?vue&type=script&lang=js"
export * from "./TourIntroComponent.vue?vue&type=script&lang=js"
import style0 from "./TourIntroComponent.vue?vue&type=style&index=0&id=6c2d5908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d5908",
  null
  
)

export default component.exports